import Layout from "../../components/user/Layout";

const PrivacyPolicy = () => {
  return (
    <Layout>
      <div className="privacy-policy py-22 ps-40 pe-40">
        <h2 className="d-flex justify-content-center fw-bold">Privacy Policy</h2>

        <section>
          <h5>1. Introduction</h5>
          <p>
            Power Trading Company ("we", "our", "us") respects your privacy and is committed to protecting personal data shared by users ("you"). This Privacy Policy explains how we collect, use, store, and protect your information when you use our mobile application.
          </p>
        </section>

        <section>
          <h5>2. Information We Collect</h5>
          <p>
            When you access or use our Services, we automatically collect information about you in the following categories:
          </p>
          <ul>
            <li><strong>Personal identifiers:</strong> Name, phone number, email address</li>
            <li><strong>Business information:</strong> Company name, GST number (if applicable)</li>
            <li><strong>Address and location data:</strong> Delivery and billing addresses</li>
            <li><strong>Transaction data:</strong> Orders, invoices, payment status (no card details stored by us)</li>
            <li><strong>Log Information:</strong> IP address, device type, app interactions, crash logs</li>
            <li><strong>Device Information:</strong> We collect information about the computer or mobile device you use to access our Services, including the hardware model, operating system and version, unique device identifiers, and mobile network information</li>
            <li><strong>Location Information:</strong> We may collect information about your location when you access or use our Services or otherwise consent to the collection of this information.</li>
            <li><strong>Cookies and Similar Technologies:</strong> We use various technologies to collect information, including cookies and web beacons. Cookies are small data files stored on your hard drive or in device memory that help us improve our Services and your experience.</li>
          </ul>
          <p>
            We do not collect sensitive personal data such as biometric data, contacts, photos, microphone, or camera data.
          </p>
        </section>

        <section>
          <h5>3. Use of Information</h5>
          <p>Your information is used to:</p>
          <ul>
            <li>Process and deliver orders of construction materials</li>
            <li>Manage payments, invoices, and customer support</li>
            <li>Comply with legal and tax requirements</li>
            <li>Improve app performance and user experience</li>
          </ul>
        </section>

        <section>
          <h5>4. Data Sharing</h5>
          <p>
            We share user data strictly on a need-to-know basis and only for app functionality:
          </p>
          <ul>
            <li>Logistics and delivery partners for order fulfillment</li>
            <li>Payment gateways for secure transaction processing</li>
            <li>Analytics and crash-reporting services to improve app stability</li>
            <li>Legal or government authorities when required by law</li>
          </ul>
          <p>
            We do not sell user data or allow third-party advertising using personal data.
          </p>
        </section>

        <section>
          <h5>5. Data Security</h5>
          <p>
            We implement reasonable security practices to protect your data against unauthorized access, loss, or misuse.
          </p>
        </section>

        <section>
          <h5>6. Data Retention</h5>
          <p>
            Data is retained only as long as necessary for business, legal, or regulatory purposes.
          </p>
        </section>

        <section>
          <h5>7. User Rights</h5>
          <p>
            In accordance with the laws and requirements, users have the right to:
          </p>
          <ul>
            <li>Access their personal data</li>
            <li>Request correction or deletion of personal information</li>
            <li>Withdraw consent for non-essential data collection</li>
          </ul>
          <p>
            Requests can be made by contacting us.
          </p>
        </section>

        <section>
          <h5>8. Changes to Policy</h5>
          <p>
            We may update this Privacy Policy from time to time. Continued use of the app implies acceptance of the updated policy.
          </p>
        </section>

        <section>
          <h5>9. Phishing or False Emails</h5>
          <p>
            If you receive any email that appears to be from us or our affiliates and requests personal information or asks you to verify your account, please treat this as a potential scam. Do not respond or click on any links. Notify us immediately at <strong>info@powergroups.in</strong>.
          </p>
        </section>

        <section>
          <h5>10. Breach Of Privacy Policy</h5>
          <p>
            If we find that you have violated our Privacy Policy, we reserve the right to immediately terminate or suspend your account without notice. This includes using false information, attempting to gain unauthorized access, or otherwise misusing our Platform.
          </p>
        </section>

        <section>
          <h5>11. No Reservations</h5>
          <p>
            We do not accept any reservations or any type of fixed consideration out of our Privacy Policy. You expressly agree to comply with all our Privacy Policy terms without any reservations.
          </p>
        </section>

        <section>
          <h5>12. Contact Information</h5>
          <p>If there are any questions regarding this privacy policy, you may contact us using the information below.</p>
          <p>
            <strong>Website:</strong>  <a href="https://www.powergroups.in" target="_blank" rel="noopener noreferrer">
                  www.powergroups.in
                </a>.<br />
            <strong>Email:info@powergroups.in</strong> <br />
            <strong>Customer Support: info@powergroups.in</strong>
          </p>
        </section>
      </div>
    </Layout>
  );
};

export default PrivacyPolicy;